import { render } from "./PopupThongTinDoanhNghiep.vue?vue&type=template&id=3c22c997"
import script from "./PopupThongTinDoanhNghiep.vue?vue&type=script&lang=js"
export * from "./PopupThongTinDoanhNghiep.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__